import { render, staticRenderFns } from "./WhatsappDelivery.vue?vue&type=template&id=6a0e31fe&scoped=true&"
import script from "./WhatsappDelivery.vue?vue&type=script&lang=js&"
export * from "./WhatsappDelivery.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappDelivery.vue?vue&type=style&index=0&id=6a0e31fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e31fe",
  null
  
)

export default component.exports